const zh = {
    num: '编号',
    operator: '操作人',
    oprtTime: '操作时间',
    oprtType: '操作类型',
    orderSource: '订单来源',
    orderStatus: '订单状态',
    orderType: '订单类型',
    printCount: '打印次数',
    prdctName: '存货名称',
    quantity: '数量',
    delTip1: '你确定要删除这个{{type}}单吗?',
    delTip2: '删除后,这个{{type}}单数据不可恢复',
    delSucc: '删除成功',
    delFail: '删除失败,{{content}}',
    orderDetails: '订单详情',
    cancel: '取消',
    confirm: '确定',
    confirm2: '确定',
    basicData: '基本数据',
    goods: '商品',
    verificaFailed: '校验失败',
    quantityTip1: '商品数量必须大于0',
    quantityTip2: '商品名称与数量格式必须正确',
    aplicatForm: '申请单',
    prdctList: '商品列表',
    fillQuantity: '请填写{{type}}数量',
    next: '下一步',
    noGood: '仓库没有该商品',
    modificatFailed: '修改失败',
    tradeName: '商品名称',
    brand: '型号',
    desc: '描述',
    unit: '单位',
    inboundOprt: '我要入库',
    outboundOprt: '我要出库',
    addFailed: '添加失败',
    prdctSource: '商品来源',
    basicInfo: '基本信息',
    creator: '制单人',
    createdAt: '制单时间',
    preparedBy: '制单人',
    preparationTime: '制单时间',
    operationSource: '操作来源',
    operationStatus: '操作状态',
    inTransit: '在途',
    inboundCompleted: '已入库',
    preparing: '备料',
    outboundCompleted: '已出库',
    modifyFail: '修改库存失败',
    sameCodeTip1: '存在相同条形码，请检查',
    view: '查看',
    noScanOrder: '扫描单不存在',
    temStorage: '临时存储',
    repeatInTip: '条形码{{code}}已存在，不可重复入库。',
    plFillInData: '请填写数据',
    plFillInDataCompletely: '请将数据填写完整！',
    tip: '提示',
    cancelTip1: '当前已有数据存在，确认取消吗？',
    sameCodeSel: '重复条码选择',
    sameCode: '重复条码：',
    plSelSpecifiedProduct: '请选择指定商品进行操作：',
    productTitle: '产品',
    productCode: '商品编码',
    barcode: '条形码',
    viewCode: '查看条形码',
    copySuccess: '复制成功！',
    copyFail: '复制失败！',
    codeListWithCount: '存有条形码列表（共计：{{count}}个）',
    copyAll: '一键复制',
    conDelTip1: '仓库中存在重复条码，是否删除以下条码？',
    conDelTip2: '仓库中该商品不存在该条码，是否删除以下条码？',
    operationSucc: '操作成功',
    saveSucTip: '临时存储成功，可在订单列表对数据进行操作！',
    saveFailTip: '临时存储失败，{{err}}',
    fetchBarcodesFailt: '查询条形码失败，{{err}}',
    searchPl: '请输入关键字进行搜索',
    searchByOrderNumber: '请输入单号进行搜索',
    startTime: '开始时间',
    endTime: '结束时间',
    confirmTip: '以下条码与仓库中所属商品不一致',
    serialMumber: '序号',
    barcodesNumber: '条形码数量',
    addDataTip: '请先添加数据',
    selectChangeTypePl: '请选择操作类型',
    preTime: '送货时间',
    confirmedTime: '实际出入库时间',
    editOrder: '编辑订单',
    quantityConfirm: '数量确认',
    updateOrderSuccess: '更新订单成功',
    onOrders: '批量下单',
    ordersComfirm: '确定批量下单？',
    optErr: "操作失败",
    signed: '已签收',
    noChanges: '没有变更',
    inOutNo: "出入库单",
    remark: '备注',
    saleOut: '销售出库',
    calcOut: '出库数据计算',
    saledQty: "已出售数量",
    productionInCount: "生产入库数量",
    toSaledQty: "待出库数量",
    curSaledQty: "本次出库数量",
    zeroTip: '至少一个物料的本次出售数量大于0',
    orderSucc: '销售出库单已创建成功',
    orderErr: '销售出库单创建失败',
    preOut: '分配库存',
    needPre: '销售出库单请先分配库存！',
    preOutSucc: '库存已分配',
    preOutErr: '库存分配失败',
    orderContitle: '确定创建销售预出库单么？',
    outOvernum: '已使用库存量超出可用库存量',
    isSwap: "是否转单单据",
};

export default zh;
